import { render, staticRenderFns } from "./CreateMailTemplateDialog.vue?vue&type=template&id=bd7876bc&scoped=true&"
import script from "./CreateMailTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./CreateMailTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateMailTemplateDialog.vue?vue&type=style&index=0&id=bd7876bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7876bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VCombobox,VDialog,VForm,VRow,VSpacer,VTextField})
